export default {
  name: 'BaseDotsLoaderComponent',
};